import { FormControl, FormLabel, Input } from '@chakra-ui/react';

import 'react-datepicker/dist/react-datepicker.css';
import React from "react";
const DateTimeField = ({ label, value, onChange, required, ...rest }) => {

  const formatDateTimeLocal = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);

    // 转换为香港时区的时间字符串
    const localDateStr = date.toLocaleString('sv-SE', { timeZone: 'Asia/Hong_Kong' });
    return localDateStr.substring(0, 16); // 截取 YYYY-MM-DDTHH:mm 部分
  };

  const formattedValue = formatDateTimeLocal(value);

  const handleDateChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue) {
      const date = new Date(inputValue);
      const isoDateString = date.toISOString(); // 转换为 ISO 8601 格式
      onChange(isoDateString);
    } else {
      onChange(null);
    }
  }

  return (
    <FormControl mb={4}>
      <FormLabel>{label}{required && (<span style={{ color: 'red' }}>*</span>)}</FormLabel>
      <Input
        type="datetime-local"
        value={formattedValue}
        onChange={handleDateChange}
      />
    </FormControl>
  );
};

export default DateTimeField;